import React from 'react';
import PropTypes from 'prop-types';
import { PromoBoxComponent, AuthorWrap, PromoBoxInner } from './ArticlePromo.styles';
import Text from '../../../shared/JssOverridesText';
import RichText from '../../../shared/JssOverridesRichText';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import { trademarkFilterHelper } from '../../../../helpers/trademarkFilterHelper';

import Button from '../../../shared/Button/Button.jsx';
import { useDeviceResize } from '../../../../hooks';
import {withSitecoreContext, isEditorActive} from '@sitecore-jss/sitecore-jss-react';
const ArticlePromoBox = ({ title, copy, author, date, itemId, sitecoreContext }) => {
  const device = useDeviceResize();
  const { site, trademarkReplacements = [] } = sitecoreContext;
  return (
    <PromoBoxComponent className={`${site.name}`}>
      <PromoBoxInner>
        {title?.value && (
            <h1
                dangerouslySetInnerHTML={{
                  __html: trademarkFilterHelper(title.value, trademarkReplacements)
                }}
            />
        )}
        {copy?.value && (
            <p className="p"
                dangerouslySetInnerHTML={{
                  __html: trademarkFilterHelper(copy.value, trademarkReplacements)
                }}
            />
        )}
        <AuthorWrap>
          {author?.length && <p>{author}</p>}
          {date?.length && <p>{date}</p>}
        </AuthorWrap>
        {/*{!isServer() && <Button type="love" size={device === 'mobile' ? 'small' : 'large'} itemId={itemId} />}*/}
      </PromoBoxInner>
    </PromoBoxComponent>
  );
};

ArticlePromoBox.propTypes = {
  title: PropTypes.object,
  copy: PropTypes.object,
  backgroundColor: PropTypes.string,
};
export default withSitecoreContext()(ArticlePromoBox);